import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { LabsConstants } from '../store/labs.constants'
import { ILabsState } from '../store/labs.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getLabsSelector } from '../selectors/labs.selector'
import { addLabsItem } from '../../../timeline/store/timeline.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveLabs() {
  let labsState: ILabsState = yield select(getLabsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    labsState = { ...labsState, nemsisCode: LabsConstants.LABS_NEMSIS_CODE }
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.labsStateList && pcrDoc.patient?.labsStateList.length) {
      const index = pcrDoc.patient?.labsStateList?.findIndex((labs) => labs.key === labsState.key)
      if (index !== -1) {
        pcrDoc.patient.labsStateList[index] = labsState
      } else {
        pcrDoc.patient?.labsStateList.push(labsState)
      }
    } else {
      pcrDoc.patient = { ...pcrDoc.patient, labsStateList: [labsState] }
    }
    try {
      const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(addLabsItem())
    } catch (e) {
      yield put(throwPcrException(`saveLabs() error: ${e}`))
    }
  }
}

export function* saveLabsSaga() {
  yield takeLatest(
    [
      LabsConstants.SET_DATE,
      LabsConstants.SET_TIME,
      LabsConstants.SET_DATE_TIME,
      LabsConstants.SET_ASSESSED_BY,
      LabsConstants.SET_ATTEMPTS,
      LabsConstants.SET_PROCEDURE_COMPLICATIONS,
      LabsConstants.SET_LAB_VALUE,
      LabsConstants.SET_AUTHORIZATION,
      LabsConstants.SET_ROLE_PERFORMING,
      LabsConstants.SET_ROLE_PERFORMING_PNNV,
      LabsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      LabsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      LabsConstants.SET_PTA,
      LabsConstants.SAVE_LABS,
    ],
    performWithMutexHOG,
    saveLabs
  )
}
